// Reload the page when a new build is live, but never while a window is open.
//
// The page's own bundle URL carries the build hash (/build/bundle.js?v=...). Every
// CHECK_MS, and whenever the page comes back to the foreground, the index page is
// fetched and its bundle hash compared. A difference means a new build; the page
// reloads at the next moment nobody is looking through the window.
import { get } from "svelte/store";
import { callActive } from "./callState.js";

const CHECK_MS = 10 * 60 * 1000;

function currentHash() {
  const script = Array.from(document.scripts).find((s) => /\/build\/bundle\.js\?v=/.test(s.src));
  const m = script && script.src.match(/\?v=([0-9a-f]+)/);
  return m ? m[1] : null;
}

async function liveHash() {
  const res = await fetch("/?update=" + Date.now(), { cache: "no-store" });
  if (!res.ok) return null;
  const html = await res.text();
  const m = html.match(/\/build\/bundle\.js\?v=([0-9a-f]+)/);
  return m ? m[1] : null;
}

export function startAutoUpdate() {
  const mine = currentHash();
  if (!mine) return;
  let pending = false;
  let timer = null;

  function reloadWhenIdle() {
    if (!pending) return;
    if (get(callActive)) { clearTimeout(timer); timer = setTimeout(reloadWhenIdle, 15000); return; }
    console.log("New build available; reloading");
    location.reload();
  }

  async function check() {
    try {
      const live = await liveHash();
      if (live && live !== mine) { pending = true; reloadWhenIdle(); }
    } catch (e) { /* offline; try again later */ }
  }

  setInterval(check, CHECK_MS);
  document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") check(); });
  setTimeout(check, 60 * 1000);
}
